<pwa-install
	#pwaInstall
	use-local-storage="true"
	[name]="name"
	[description]="description"
	(pwa-install-how-to-event)="eventHandle($event)"
></pwa-install>

@if (pwaInstallState() === 'installable') {
<div libFlexRow>
	<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : undefined">
		<lib-button (click)="show()" [buttonType]="buttonType()" [icon]="'download_app'">Install app</lib-button>
	</div>
</div>
} @else if (pwaInstallState() === 'installed') {
<em>Already installed</em>
} @else if (pwaInstallState() === 'notSupported') {
<em
	>Installation not supported on this device.<br />
	Please use a mobile or tablet.</em
>
}
